import { MEXICO_PROVINCES } from "_common/regions/regions";
import { TAttraction } from "_common/attractions/attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";

export const bcsAttraction: TAttraction[] = [
    {
        name: "Los Cabos International Airport (SJD)",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 23.1455358,
            lng: -109.7208468,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "La Paz International Airport (LAP)",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.0761434,
            lng: -110.3697257,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Loreto International Airport (LTO)",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 25.9926501,
            lng: -111.3529565,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Tijuana International Airport (TIJ)",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 32.5408452,
            lng: -116.9716335,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Cabo - Playa Hotelera",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9834166,
            lng: -109.887374,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Las Palmas",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9834166,
            lng: -109.887374,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Costa Azul",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9834166,
            lng: -109.887374,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Palmilla",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Tequila Cove Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Chileno Bay Public Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Santa Maria Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Viudas",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Cabo Bello",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.9830796,
            lng: -109.8891484,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa El Farito",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Pública Cabo San Lucas",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa de los Amantes",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa Coral Negro",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Pedregal Playa",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Cabo - Playa El Faro",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 22.8932261,
            lng: -109.9400575,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Punta Mita - Punta Mita Public Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 20.7744763,
            lng: -105.5250244,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Careyeros",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 20.7841369,
            lng: -105.5103743,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Litibú Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 20.8053499,
            lng: -105.4804157,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Cet Mar Beach",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.1440417,
            lng: -110.4001581,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa el Mogote",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.1715348,
            lng: -110.4338062,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa El Conchalito",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.1546931,
            lng: -110.4090845,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - El Malecón de La Paz",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.1553874,
            lng: -110.3227178,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa La Concha",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2018323,
            lng: -110.2996679,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa La Caimancito",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2054671,
            lng: -110.299967,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa Las Tortugas",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2100733,
            lng: -110.2997273,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "La Paz - Playa El Tesoro",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2545631,
            lng: -110.314923,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Pichilingue",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2849,
            lng: -110.3272432,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Gaviotas",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2822171,
            lng: -110.3530113,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Balandra",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2822171,
            lng: -110.3530113,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa El Tecolote",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.3361029,
            lng: -110.3361625,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa El Saltito",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 24.2438342,
            lng: -110.1463509,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa La Libertad",
        region: MEXICO_PROVINCES.BAJA_CALIFORNIA_SUR,
        coordinates: {
            lat: 23.5927344,
            lng: -109.5888258,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
